import { compact } from "lodash";
/**
 * @function modelMergeAccountBalanceTransferPaymentSummary
 * @param {*} transactionData.transaction
 * @param {string|undefined} transactionData.account
 * @param {function} formatMessage
 * @returns {PaymentSummaryData}
 */

export const modelMergeAccountBalanceTransferPaymentSummary = (
  { transaction, accountId },
  formatMessage
) => {
  const { transaction_data } = transaction;
  const { destination_wallet_id, source_account_id, source_wallet_id, currency, amount } =
    transaction_data.transfer_items[0];
  const wallets = transaction_data.wallets;
  const walletId = source_account_id === accountId ? source_wallet_id : destination_wallet_id;

  const wallet = wallets[walletId];

  return {
    title: formatMessage({ defaultMessage: "Transferred from", description: "Field Label" }),
    rows: [
      {
        title: wallet.description,
        value: amount,
        currency,
      },
    ],
    secondaryData: null,
  };
};

/**
 * @function modelFundUserBalanceTransferPaymentSummary
 * @param {*} transactionData.transaction
 * @param {string|undefined} transactionData.account
 * @param {function} formatMessage
 * @returns {PaymentSummaryData}
 */

export const modelFundUserBalanceTransferPaymentSummary = ({ transaction }, formatMessage) => {
  const { transaction_data } = transaction;
  const transfer_items = transaction_data.transfer_items;
  const wallets = transaction_data.wallets;
  const value = transfer_items[0].amount;
  const currency = transfer_items[0].currency;
  const walletId = transfer_items[0].destination_wallet_id;
  const wallet = wallets[walletId];

  return {
    title: formatMessage({ defaultMessage: "Deposited into", description: "Field Label" }),
    rows: [
      {
        title: wallet.description,
        value,
        currency,
      },
    ],
    secondaryData: null,
  };
};

const makePayoutReversalRow = (transaction, type, walletType) => {
  const { transaction_data } = transaction;
  const transfer_items = transaction_data.transfer_items;
  const wallets = transaction_data.wallets;

  const transferItem = transfer_items.find((ti) => ti.subitem_type === type);

  if (transferItem) {
    const wallet = wallets[transferItem[walletType]];
    return {
      title: wallet.description,
      value: transferItem.amount,
      currency: transferItem.currency,
    };
  } else {
    return null;
  }
};

/**
 * @function modelTokenPayoutReversalBalanceTransferPaymentSummary
 * @param {*} transactionData.transaction
 * @param {string|undefined} transactionData.account
 * @param {function} formatMessage
 * @returns {PaymentSummaryData}
 */
export const modelTokenPayoutReversalBalanceTransferPaymentSummary = (
  { transaction },
  formatMessage
) => {
  return {
    title: formatMessage({ defaultMessage: "Transferred from", description: "Field Label" }),
    // find the amount that was deposited in usd
    rows: [
      makePayoutReversalRow(transaction, "token_convert_usd_credit_reversal", "source_wallet_id"),
    ],
    // display all the credited amount
    secondaryData: {
      title: formatMessage({
        defaultMessage: "Deposited into",
        description: "Field Label",
      }),
      rows: compact([
        makePayoutReversalRow(
          transaction,
          "token_convert_virtual_debit_reversal",
          "destination_wallet_id"
        ),
        makePayoutReversalRow(
          transaction,
          "token_convert_integrator_fee_reversal",
          "destination_wallet_id"
        ),
        makePayoutReversalRow(
          transaction,
          "token_convert_tilia_fee_reversal",
          "destination_wallet_id"
        ),
      ]),
    },
  };
};

/**
 * @function modelBalanceTransferPaymentSummary
 * @param {*} transactionData.transaction
 * @param {string|undefined} transactionData.account
 * @param {function} formatMessage
 * @returns {PaymentSummaryData}
 */

export const modelBalanceTransferPaymentSummary = ({ transaction, accountId }, formatMessage) => {
  const { transaction_data } = transaction;

  switch (transaction_data.balance_transfer_type) {
    case "merge_account":
      return modelMergeAccountBalanceTransferPaymentSummary(
        { transaction, accountId },
        formatMessage
      );
    case "fund_user":
      return modelFundUserBalanceTransferPaymentSummary({ transaction, accountId }, formatMessage);
    case "token_convert_payout_reversal":
      return modelTokenPayoutReversalBalanceTransferPaymentSummary(
        { transaction, accountId },
        formatMessage
      );

    default:
      return null;
  }
};
